"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _videoControls = _interopRequireDefault(require("./video-controls"));

var _default = _videoControls.default;
exports.default = _default;